module.exports = require("node-html-to-image");